import React, { useEffect } from "react";

import Hero from "components/Hero";
import Servizi from "components/Servizi";
import Piatti from "components/Piatti";

import logo from "images/bi/logo_rabarbaro.png";
import video from "video/rabarbaro_home-orizzontale.mp4";

import { heroCarousel, piatti } from "site-structure";

const Home = ({ title }) => {
	useEffect(() => {
		document.title = title;
	}, [title]);

	return (
		<>
			<Hero
				video={video}
				overtitle={heroCarousel[0].subtitle}
				logo={logo}
				cta={true}
			/>

			<div className="main">
				<Servizi />

				<Piatti
					overtitle="Li abbiamo fatti noi?"
					title="Se sì, non abbiamo fatto apposta"
					gallery={piatti}
				/>
			</div>
		</>
	);
};

export default Home;
